import React, { Component } from 'react';
import memoizeOne from 'memoize-one';
import _get from 'lodash.get';

import { replaceBucketKeysWithUrlsInArray } from '@shootsta/client-aws-s3';
import CommentsContext from '../contexts/commentsContext';
import commentsContextSelector from '../selectors/commentsContext';
import { getUserColor, generateUserColors } from '../utils';
import orderByTimestamp from '../utils/orderByTimestamp';
import parseJSON from '../../../common/utils/parseJSON';
import resolveProfileImages from '../../CollaborationProvider/utils/resolveProfileImages';




















































export default class CommentsProvider extends Component {
  getUserColors = memoizeOne(({ comments }) =>
  generateUserColors({ userIds: comments.map(({ createdByUser: { userId } }) => userId) })
  );

  constructor(props) {
    super(props);

    const comments = new Map([]);

    this.state = {
      comments,
      userAssignedColors: {},
      commentModalProps: {}
    };
  }

  componentDidMount() {
    const {
      resourceId,
      resourceOrganisationId,
      shouldNotFetchOnMount = false
    } = this.props;

    if (!shouldNotFetchOnMount) {
      this.fetchComments(resourceId);
    }

    if (resourceOrganisationId) {
      this.getOrganisationDetails();
    }
  }

  componentDidUpdate(prevProps) {
    const { resourceId: prevResourceId } = prevProps;
    const { resourceId } = this.props;

    if (
    prevResourceId === resourceId)
    {
      return;
    }

    this.fetchComments(resourceId, null);
  }

  getFilteredSceneComments = (
  comments,
  commentSceneId) =>
  {
    const sceneComments = new Map();

    comments.forEach((value, key) => {
      if (commentSceneId === value.sceneId) {
        sceneComments.set(key, value);
      }
    });

    return commentSceneId ? sceneComments : comments;
  };

  getFilteredShotComments = (
  comments,
  commentsShotId) =>
  {
    const shotComments = new Map();

    comments.forEach((value, key) => {
      if (commentsShotId === value.shotId) {
        shotComments.set(key, value);
      }
    });

    return commentsShotId ? shotComments : comments;
  };


  getFilteredCommentsForResource = (
  resourceId, comments) =>
  {
    const { filterByMetadataFlag, versionIds } = this.props;
    const newComments = new Map();

    let resourceIds = [resourceId];

    if (resourceId && Array.isArray(versionIds)) {
      resourceIds = [...resourceIds, ...versionIds];
    }

    comments.forEach((value, key) => {
      const isCommentResource = resourceIds.find((versionId) => versionId === value.resourceId);

      if (!isCommentResource) {
        return;
      }

      if (!filterByMetadataFlag) {
        return void newComments.set(key, value);
      }

      if (!value.metadata) {return;}

      const metadata = parseJSON(value.metadata);

      const isMetadataMatchFilters = Object.entries(filterByMetadataFlag).
      every(([metaKey, metaValue]) => metadata[metaKey] === metaValue);

      if (!isMetadataMatchFilters) {return;}

      return void newComments.set(key, value);
    });

    return newComments;
  };

  fetchUserColor = ({ userId } = {}) => {
    const { userAssignedColors } = this.state;
    const { userColor, updatedUserColors } = getUserColor(
      { userAssignedColors, userId }
    );

    if (updatedUserColors) {
      this.setState({ userAssignedColors: updatedUserColors });
    }

    return userColor;
  };

  fetchComments = async (resourceId, filterParams) => {
    const {
      getCommentsRequest,
      fetchAssets,
      apiClient,
      resourceOrganisationId,
      versionIds,
      commentOrigin,
      notCommentOrigin,
      currentActivePage
    } = this.props;
    const {
      organisationPreferences: { isSignOffWorkflowEnabled = false } = {}
    } = this.state;

    const filters = {
      ...(isSignOffWorkflowEnabled ? filterParams || {} : {}),
      page: filterParams?.page?.length ? [currentActivePage] : []
    };

    if (!resourceId) return;
    const { data, error } = await getCommentsRequest({
      resourceId,
      versionIds,
      filters: {
        ...(filters && Object.keys(filters).length ? filters : {}),
        ...(commentOrigin ? { commentOrigin: [commentOrigin] } : {}),
        ...(notCommentOrigin ? { notCommentOrigin: [notCommentOrigin] } : {})
      }
    });

    if (error || !data || !data.getComments && !data.getPublicComments) {return;}

    if (fetchAssets) fetchAssets(data);

    const comments = data.getComments || data.getPublicComments;

    if (data.getPublicComments) {
      this.setState({
        comments,
        userAssignedColors: this.getUserColors({ comments })
      });
      return;
    }

    const commentsWithRootProfileImages = await replaceBucketKeysWithUrlsInArray({
      apiClient,
      dataArray: comments,
      substitutedKeys: [{ key: 'createdByUser', subKeys: ['imageUrl'] }],
      organisationId: resourceOrganisationId
    });

    const commentsWithViewersProfileImages = await Promise.all(
      commentsWithRootProfileImages.map(async (comment) => {
        if (!comment.viewers) {return comment;}

        const updatedViewers = await resolveProfileImages(
          comment.viewers,
          resourceOrganisationId,
          apiClient);
        return { ...comment, viewers: updatedViewers };
      }
      )
    );

    const commentsWithChildrenImages = commentsWithViewersProfileImages.map((comment) => {
      const { children } = comment;

      if (!children || !children.length) {return comment;}

      const resolvedChildren = children.map((childComment) => {
        const { commentId } = childComment;
        const resolvedComment = commentsWithViewersProfileImages.find((searchComment) =>
        searchComment.commentId === commentId
        );

        return {
          ...childComment,
          createdByUser: resolvedComment.createdByUser
        };
      });

      return { ...comment, children: resolvedChildren };
    });

    const commentsMap = new Map(commentsWithChildrenImages.map((comment) => [
    comment.commentId,
    comment]
    ));

    const orderedComments = commentOrigin === 'REVIEW' ?
    this.getOrderedRejectionComments(commentsWithChildrenImages) :
    commentsMap;

    this.setState({
      comments: orderedComments,
      userAssignedColors: this.getUserColors({ comments })
    });
  };

  handleCommentAssetsChange = (
  prevAssetIds = [],
  newAssetIds = []) =>
  {
    const { onCommentAssetsChange } = this.props;

    const deleted = prevAssetIds.filter((assetId) => !newAssetIds.includes(assetId));
    const created = newAssetIds.filter((assetId) => !prevAssetIds.includes(assetId));

    if (!onCommentAssetsChange || !deleted.length && !created.length) {return;}

    onCommentAssetsChange({ deleted, created });
  };

  handleCommentUpdate = (newComment) => {
    const { commentOrigin } = this.props;

    this.setState(({ comments: prevCommentsMap }) => {
      const existingComment = prevCommentsMap.get(newComment.commentId) || {};
      const comments = new Map([
      ...prevCommentsMap,
      [newComment.commentId, {
        ...existingComment,
        ...newComment,
        fetching: false
      }]]
      );

      const orderedRejectComment = commentOrigin === 'REVIEW' ?
      this.getOrderedRejectionComments(comments) :
      comments;

      this.handleCommentAssetsChange(existingComment.assetIds, newComment.assetIds);

      return {
        comments: orderedRejectComment,
        userAssignedColors: this.getUserColors({ comments: Array.from(comments.values()) })
      };
    });
  };

  deleteComment = async ({ commentId, onSuccess }) => {
    const { deleteCommentRequest } = this.props;

    const { error } = await deleteCommentRequest({ commentId });

    if (error) {return;}

    this.setState(({ comments: prevCommentsMap }) => {
      const newMap = new Map([...prevCommentsMap]);

      this.handleCommentAssetsChange(_get(newMap.get(commentId), 'assetIds'), []);

      newMap.delete(commentId);

      return { comments: newMap };
    }, () => {
      if (!onSuccess) {return;}

      onSuccess({ commentId });
    });
  };

  deleteReply = async (
  {
    commentId,
    parentComment,
    parentComment: { children = [] }
  }) =>
  {
    const { deleteCommentRequest } = this.props;

    const { error } = await deleteCommentRequest({ commentId });

    if (error) {return;}

    const replyIndex = children.findIndex((child) => child.commentId === commentId);

    this.handleCommentUpdate({
      ...parentComment,
      children: [...children.slice(0, replyIndex), ...children.slice(replyIndex + 1)]
    });
  };

  editReply = async ({
    commentId,
    input,
    parentComment




  }) => {
    const { children = [] } = parentComment;

    const {
      updateCommentRequest,
      relatedToId,
      relatedToType,
      shotId,
      sceneId,
      disableNotifications
    } = this.props;

    const { data, error } = await updateCommentRequest({
      commentId,
      input: {
        ...input,
        relatedToId,
        relatedToType,
        shotId,
        sceneId,
        disableNotifications
      }
    });

    if (error || !data) {return { error };}

    const updatedChild = children.map((child) => {
      if (child.commentId === commentId) {
        return { ...child, ...input };
      }
      return child;
    });

    return this.handleCommentUpdate({
      ...parentComment,
      children: updatedChild
    });
  };

  createComment = async ({ input }) => {
    const {
      createCommentRequest,
      resourceId,
      relatedToId,
      relatedToType,
      disableNotifications = false,
      isInternalMode
    } = this.props;

    const requestPayload = {
      ...input,
      resourceId,
      relatedToId,
      relatedToType,
      disableNotifications
    };

    if (isInternalMode) {
      const nonInternalVisibility = ['PUBLIC', 'INTERNAL'];

      const inputMetaData = JSON.parse(input.metadata);
      const { visibility = null } = inputMetaData || {};

      requestPayload.metadata = JSON.stringify({
        ...inputMetaData,
        internalMode: true,
        ...(visibility && nonInternalVisibility.includes(visibility) ? { internalMode: false } : {})
      });
    }

    const { data, error } = await createCommentRequest(requestPayload);

    if (!data || error) {return { data, error };}

    this.handleCommentUpdate(data.createComment);

    return { data };
  };

  createReply = async (
  {
    input,
    parentComment,
    parentComment: { children = [] }
  }) =>
  {
    const { createCommentRequest, resourceId, disableNotifications } = this.props;

    const { data, error } = await createCommentRequest({
      ...input,
      resourceId,
      disableNotifications
    });

    if (error || !data) {return { error };}

    const updatedComment = {
      ...parentComment,
      children: [
      ...children,
      data.createComment]

    };

    this.handleCommentUpdate(updatedComment);

    return { data };
  };

  updateComment = async (commentId, input) => {
    const { updateCommentRequest, relatedToId, relatedToType, disableNotifications } = this.props;

    if (!input.metadata) {
      const { comments } = this.state;
      const existingComment = comments.get(commentId);

      if (existingComment) {
        this.handleCommentUpdate({
          ...existingComment,
          ...input,
          commentId
        });
      }
    }

    const { data, error } = await updateCommentRequest(
      {
        commentId,
        input: {
          relatedToId,
          relatedToType,
          disableNotifications,
          ...input
        }
      });

    if (error || !data) {return { error };}

    return { data };
  };

  showCommentModal = (id, commentModalProps) => {
    if (!id) {return;}

    this.setState({
      commentModalId: id,
      commentModalProps: {
        ...commentModalProps
      }
    });
  };

  closeCommentModal = ({ closeModalOrigin } = {}) => {
    this.setState({ commentModalId: void 0, commentModalProps: void 0, closeModalOrigin });
  };

  getOrderedRejectionComments = (
  filteredComments) =>
  {
    const commentsArray = Array.from(filteredComments.values());

    const rejectedComments = commentsArray.filter((comment) => {
      const metadata = comment.metadata ? parseJSON(comment.metadata) : {};
      return metadata.isRejected;
    });

    const sortedRejectedComments = rejectedComments.sort(
      (a, b) => Number(b.updatedAt) - Number(a.updatedAt)
    );

    const nonRejectedComments = commentsArray.filter((comment) => {
      const metadata = comment.metadata ? parseJSON(comment.metadata) : {};
      return !metadata.isRejected;
    });

    const orderedComments = [...sortedRejectedComments, ...nonRejectedComments];

    return new Map(orderedComments.map((comment) => [comment.commentId, comment]));
  };

  getOrderedComments = (clipId, sceneId, shotId) => {
    const { resourceId, commentOrigin } = this.props;
    const { userAssignedColors, comments } = this.state;

    const filteredCommentsResource = this.getFilteredCommentsForResource(resourceId, comments);
    const filteredSceneComments = this.getFilteredSceneComments(filteredCommentsResource, sceneId);
    const filteredComments = this.getFilteredShotComments(filteredSceneComments, shotId);
    const orderRejectionComments = commentOrigin === 'REVIEW' ?
    this.getOrderedRejectionComments(filteredComments) :
    filteredComments;

    return orderByTimestamp(userAssignedColors, orderRejectionComments, clipId);
  };

  getTotalParentComments = () => {
    const { comments } = this.state;

    return Array.from(comments.values()).filter((comment) => !comment.parentId).length;
  };

  getOrganisationDetails = async () => {
    const {
      getOrganisation
    } = this.props;

    const { data, error } = await getOrganisation();

    if (error || !data || !data.getOrganisation) {return;}

    const { name: organisationName, preferences: organisationPreferences } = data.getOrganisation;

    if (organisationName) {
      this.setState({
        organisationName,
        organisationPreferences
      });
    }
  };

  setSelectedComment = (comment) => {
    this.setState({ selectedComment: comment });
  };

  render() {
    const {
      comments,
      userAssignedColors,
      commentModalId,
      commentModalProps,
      closeModalOrigin,
      organisationName,
      selectedComment
    } = this.state;
    const {
      children,
      updateViewersRequest,
      filterByMetadataFlag,
      resourceId,
      resourceOrganisationId,
      canResolveComment,
      isReadOnly,
      modalTarget,
      resourceOwnerUserId,
      fetchAssets,
      assetsMap,
      allowedVisibilityOptions,
      allowedWriteVisibilityOptions,
      isInternalMode,
      commentOrigin,
      notCommentOrigin,
      currentActivePage,
      pagesList
    } = this.props;

    return (
      <CommentsContext.Provider
        value={commentsContextSelector({
          state: {
            comments: this.getFilteredCommentsForResource(resourceId, comments),
            resourceOwnerUserId,
            userAssignedColors,
            commentModalId,
            commentModalProps,
            modalTarget,
            filterByMetadataFlag,
            isReadOnly,
            canResolveComment,
            resourceOrganisationId,
            closeModalOrigin,
            assetsMap,
            organisationName,
            allowedVisibilityOptions,
            allowedWriteVisibilityOptions,
            isInternalMode,
            commentOrigin,
            notCommentOrigin,
            currentActivePage,
            pagesList,
            selectedComment
          },
          actions: {
            deleteComment: this.deleteComment,
            updateComment: this.updateComment,
            createComment: this.createComment,
            createReply: this.createReply,
            updateViewers: updateViewersRequest,
            editReply: this.editReply,
            deleteReply: this.deleteReply,
            getUserColor: this.fetchUserColor,
            showCommentModal: this.showCommentModal,
            closePopover: this.closeCommentModal,
            getOrderedComments: this.getOrderedComments,
            getTotalParentComments: this.getTotalParentComments,
            fetchAssets,
            fetchComments: this.fetchComments,
            setSelectedComment: this.setSelectedComment
          }
        })}>

        {children}
      </CommentsContext.Provider>);

  }
}